import * as React from "react";
import {useEffect, useState} from "react";
import {Button, InputNumber, Popover, Slider} from "antd";
import {CloseOutlined} from "@ant-design/icons";

interface NpTagProps {
    closeSelectDropdown: ()=>void
    onRemove: (event?: React.MouseEvent<HTMLElement, MouseEvent>)=>void
    value: string
    setValue: (value: string)=>void
    npOpen: boolean
    setNpOpen: (open: boolean)=>void
}

export function NpTag(props: NpTagProps) {
    const [np, setNp] = useState<string>("90")

    useEffect(()=>{
        if (props.value.startsWith("np:")) {
            const val = props.value.split(':', 2)[1].trim()
            setNp(val)
        }
    }, [props.value])

    function getButtonTitle() {
        if (!props.value || props.value==='np') return "Set minimum NIH Percentile"
        return "NP>=" + props.value.split(':', 2)[1].trim()
    }

    return <div className={'tag'} onMouseDown={e=>e.stopPropagation()}>
        <Popover content={
            <div style={{display: "flex", gap: 10, flexDirection: "column", alignItems: "flex-end"}}>
                <div style={{display: "flex", gap: 16}}>
                    <Slider
                        style={{flex: 1, width: 200}}
                        min={0}
                        max={99}
                        onChange={v=>setNp(v.toString())}
                        value={Number(np)}
                        step={1}
                    />
                    <InputNumber
                        min={0}
                        max={99}
                        step={1}
                        value={Number(np)}
                        onChange={v=>v && setNp(v.toString())}
                    />
                </div>
                <div>
                    <Button type={"primary"} onClick={()=>{
                        props.setValue(np)
                        props.setNpOpen(false)
                    }}>OK</Button>
                </div>
            </div>}
                 style={{width: 400}}
                 arrow={false}
                 trigger={'click'}
                 placement={"bottomLeft"}
                 destroyTooltipOnHide={true}
                 align={{offset: [0, 6]}}
                 onOpenChange={(open)=>{
                     if (open) {
                         props.closeSelectDropdown()
                     }
                     props.setNpOpen(open)
                 }}
                 open={props.npOpen}
        >
            <Button size={"small"} type={'link'}>{getButtonTitle()}</Button>
        </Popover>
        <Button type={'text'} size={"small"} className={'close-tag'} onClick={props.onRemove}><CloseOutlined/></Button>
    </div>
}

